<yc-modal *ngIf="formGroup"
  [modalHeader]="'PROGRAM:textArchiveCycle' | ycI18n: 'Archive Cycle'"
  [modalSubHeader]="cycleName"
  [primaryButtonText]="'GLOBAL:textArchive' | ycI18n"
  [cancelButtonText]="'common:btnCancel' | ycI18n"
  (onCancel)="closeModal.emit()"
  (onPrimaryClick)="onSubmit()">
  <div class="d-flex mb-4">
    <!-- Total Applications -->
    <div class="flex-fill">
      <div>
        <yc-i18n
          [key]="isNomination ?
            'common:lblTotalNominations' :
            'common:lblTotalApplications'"
          [defaultValue]="isNomination ?
            'Total Nominations' :
            'Total Applications'">
        </yc-i18n>
      </div>
      <div class="header-stats">
        <yc-fa
          icon="clipboard-list"
          [light]="true"
          class="text-link me-2">
        </yc-fa>
        {{ stats.totalApplications | number }}
      </div>
    </div>

    <ng-container *ngIf="!isNomination">
      <!-- Total Awards -->
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="AWARDS:textTotalAwards"
            defaultValue="Total Awards">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="gift"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ stats.totalAwards | gcMoney }}
        </div>
      </div>

      <!-- Total Payments -->
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="GLOBAL:textTotalPaymentsUpperCase"
            defaultValue="Total Payments">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="money-bill-wave-alt"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ stats.totalPayments | gcMoney }}
        </div>
      </div>

      <!-- Payments Available For Processing -->
      <div class="flex-fill">
        <div>
          <yc-i18n
            key="GLOBAL:textPaymentsAvailableForProcessing"
            defaultValue="Payments Available for Processing">
          </yc-i18n>
        </div>
        <div class="header-stats">
          <yc-fa
            icon="money-bill"
            [light]="true"
            class="text-link me-2">
          </yc-fa>
          {{ stats.paymentsAvailableForProcessing | gcMoney }}
        </div>
      </div>
    </ng-container>
  </div>
  <div>
    <yc-i18n
      [key]="isNomination ?
        'PROGRAM:textArchiveCycleConfirmNom' :
        'PROGRAM:textArchiveCycleConfirmApp'"
      [context]="{
        cycleName: cycleName
      }"
      [defaultValue]="isNomination ?
        'Archiving __cycleName__ will archive all nominations, removing them from most views.' :
        'Archiving __cycleName__ will archive all applications, removing them from most views.'">
    </yc-i18n>

    <ng-container
      [formGroup]="formGroup">
      <!-- Comment -->
      <div class="row mt-3">
        <div class="col-md-12">
          <yc-textarea
            name="comment"
            [label]="'common:labelComment' | ycI18n: 'Comment'"
            [maxLength]="2000">
          </yc-textarea>
        </div>
      </div>
    </ng-container>
  </div>
</yc-modal>